<!--suppress AngularNgOptimizedImage, JSUnresolvedReference -->
<div class="d-flex w-100 align-items-center justify-content-center flex-column">
  <div class="logo">
    <img src="/views/getlogo/" alt="logo" />
  </div>
  @if (luser | async; as user) {
    <div class="welcome">
      <span class="fw-lighter text-secondary" i18n>Welcome</span
      ><span class="fw-light text-primary"> {{ user.firstname }} {{ user.lastname }}</span>
    </div>

    <div class="controlz">
      <ng-container *ngTemplateOutlet="controlz"></ng-container>
    </div>
  }
</div>

<ng-template #controlz>
  <div class="row">
    <div class="col-md-12">
      <div class="d-flex flex-row align-items-center justify-content-around flex-wrap">
        <div
          routerLink="/assets"
          class="control d-flex flex-column align-items-center justify-content-center"
        >
          <tui-svg [src]="'mat::asset'" class="icon"></tui-svg>
          <div class="title">Assets</div>
        </div>
        <div
          routerLink="/companies"
          class="control d-flex flex-column align-items-center justify-content-center"
        >
          <tui-svg [src]="'mat::company'" class="icon"></tui-svg>
          <div class="title">Companies</div>
        </div>
        <div
          routerLink="/categories"
          class="control d-flex flex-column align-items-center justify-content-center"
        >
          <tui-svg [src]="'mat::categories'" class="icon"></tui-svg>
          <div class="title">Categories</div>
        </div>
        <div
          routerLink="/locations"
          class="control d-flex flex-column align-items-center justify-content-center"
        >
          <tui-svg [src]="'mat::location'" class="icon"></tui-svg>
          <div class="title">Locations</div>
        </div>
      </div>
    </div>
  </div>
  <div class="row my-5">
    <div class="col-md-12">
      <div class="d-flex flex-row align-items-center justify-content-center flex-wrap">
        <div
          routerLink="/projects"
          class="control d-flex flex-column align-items-center justify-content-center"
        >
          <tui-svg [src]="'mat::project'" class="icon"></tui-svg>
          <div class="title">Projects</div>
        </div>
        <div
          routerLink="/scans"
          class="control d-flex flex-column align-items-center justify-content-center"
        >
          <tui-svg [src]="'mat::scan'" class="icon"></tui-svg>
          <div class="title">Scan</div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
